/*
 * Special-Navi und Breadcrumb
 */
/**
 * @namespace Breadcrumbnavigation
 */
Planet.Breadcrumbnavigation = function ($) {

  /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */

  var NAME = 'breadcrumbnavigation';
  var DATA_KEY = 'planet.' + NAME;
  var EVENT_KEY = '.' + DATA_KEY;
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $.fn[NAME];

  var Event = {
    PJAX_DATA_API: 'pjax:end' + EVENT_KEY + DATA_API_KEY
  };

  var Selector = {
    DATA_SPY: '.linkliste[data-navilist]'
  };

  /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */
  // function Replacement(element, target) {
  //   var self = this;
  //   self.element = element;
  //   self.element.prependTo(target);
  // };
  var Breadcrumbnavigation = function () {
    function Breadcrumbnavigation(element) {
      var self = this;

      // protected
      self.element = element;
      self.$element = $(self.element);
      self.bc = self.$element.find('ul');
      self.config = {};

      self.config.isBreadcrumb = self.bc;

      //Fügt der Subnavi die Breite hinzu:
      const body = $("body")[0];
      const scrollbar = window.innerWidth - body.clientWidth;
      const navilist = $('[data-navilist="planet-detail"]');
      navilist.attr('style', `width: calc(100vw - ${scrollbar}px)`);
      // navilist.setAttribute("style", `--scrollbar: ${scrollbar}px`);

      // FIX
      if (!self.bc.parent().is('nav')) {
        self.bc.wrap('<nav />');
      }
      self.bc.addClass("bc");
      self.element = self.bc.parent()[0];
      self.$element = self.bc.parent();

      // render
      self.$element.addClass('navswiper-container');
      var $ul = self.$element.children('ul, ol');
      $ul.addClass('navswiper-wrapper');
      $ul.children('li').addClass('navswiper-slide');
      $ul.before('<button class="navswiper-button-prev">' +
        '<span class="sr-only">Nach links</span>');
      $ul.after('<button class="navswiper-button-next">' +
        '<span class="sr-only">Nach rechts</span>');

      self.swiper = new Swiper(self.element, {
        freeMode: true,
        slidesPerView: 'auto',
        centeredSlides: false,
        containerModifierClass: 'navswiper-container-',
        slideClass: 'navswiper-slide',
        slideActiveClass: 'navswiper-slide-active',
        slideDuplicateActiveClass: 'navswiper-slide-duplicate-active',
        slideVisibleClass: 'navswiper-slide-visible',
        slideDuplicateClass: 'navswiper-slide-duplicate',
        slideNextClass: 'navswiper-slide-next',
        slideDuplicateNextClass: 'navswiper-slide-duplicate-next',
        slidePrevClass: 'navswiper-slide-prev',
        slideDuplicatePrevClass: 'navswiper-slide-duplicate-prev',
        wrapperClass: 'navswiper-wrapper',
        a11y: {
          // enabled: false
          prevSlideMessage: 'Nach vorne blättern',
          nextSlideMessage: 'Nach hinten blättern'
        },
        navigation: {
          prevEl: ".navswiper-button-prev",
          nextEl: ".navswiper-button-next",
          disabledClass: "hidden"
        },
        on: {
          init: function (swiperInstance) {
            if (self.config.isBreadcrumb) {
              swiperInstance.slideTo(0, 500, false);
            } else {
              var index = Array.from(swiperInstance.slides).findIndex(function (slide) {
                return slide.classList.contains("active");
              });
              swiperInstance.slideTo(0, 500, false);
            }
          },
          reachBeginning: function (swiperInstance) {
            console.log("reachBeginning");
          },
          fromEdge: function (swiperInstance) {
            console.log("fromEdge");
          }
        }

      });
    }

    // public
    Breadcrumbnavigation.prototype.dispose = function dispose() {
      this.$element.off(EVENT_KEY);

      this.$element = null;
      this.element = null;

      $(document).off(EVENT_KEY);
    };

    // static
    Breadcrumbnavigation._jQueryInterface = function _jQueryInterface() {
      return this.each(function () {
        var data = $(this).data(DATA_KEY);

        if (!data) {
          data = new Breadcrumbnavigation(this);
          $(this).data(DATA_KEY, data);
        }
      });
    };

    return Breadcrumbnavigation;
  }();

  /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    // var target = $("#article");
    // Replacement($element, target);
    Breadcrumbnavigation._jQueryInterface.call($element);
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      // var target = $("#article");
      // Replacement($element, target);
      Breadcrumbnavigation._jQueryInterface.call($element);
    });
  });

  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $.fn[NAME] = Breadcrumbnavigation._jQueryInterface;
  $.fn[NAME].Constructor = Breadcrumbnavigation;
  $.fn[NAME].noConflict = function () {
    $.fn[NAME] = JQUERY_NO_CONFLICT;
    return Breadcrumbnavigation._jQueryInterface;
  };

  return Breadcrumbnavigation;

}(window.jQuery);


/**
 *
 */
(function ($) {
  var Event = {
    PJAX_DATA_API: 'pjax:end'
  };
  var Selector = {
    DATA_SPY: '.linkliste[data-navilist]'
  };
  var fixElements = function () {
    return this.each(function () {
      var $element = $(this);
      var dis = $element.offset().top, $window = $(window);
      function fixingSubnvi() {
        var grid = new Grid();
        if (0 !== $element.length) {
          if (grid.isBp(['sm', 'md', 'lg', 'xl'])) {
            if ( $window.scrollTop() >= dis ) {
              $element.addClass( 'fixy' );
            } else {
              $element.removeClass( 'fixy' );
            }
          }
        }
      }
      $window.on('scroll resize', fixingSubnvi);
    });
  };
  $(Selector.DATA_SPY).each(function () {
    var $element = $(this);
    fixElements.call($element);
  });
  $(document).on(Event.PJAX_DATA_API, function (event, xhr, options) {
    $(options.container).find(Selector.DATA_SPY).each(function () {
      var $element = $(this);
      fixElements.call($element);
    });
  });
})(window.jQuery);
